import React, { FC } from 'react';
import { ModalManager, ModalRouteProps } from 'context/ModalRouter';
import { queryKey } from 'constants/queryKey';
import { useQuery } from 'react-query';
import { usePage } from 'modules/page/pageSelector';
import { useUser } from 'modules/user/userSelector';
import PostApi from 'api/post';
import DuplicatePostsModal from 'app/modules/posts/modules/duplicatePosts/components/DuplicatePostsModal';
import { useInvalidatePostsQueries } from 'app/modules/posts/hooks/useInvalidatePostsQueries';

type Props = {
  modalManager: ModalManager;
} & ModalRouteProps;

const DashboardDuplicatePostsModal: FC<Props> = (props) => {
  const { pages } = usePage();
  const user = useUser();
  const invalidatePostsQueries = useInvalidatePostsQueries();

  const modalManager: ModalManager = {
    ...props.modalManager,
    close: () => {
      props.modalManager.close();
      invalidatePostsQueries();
    },
  };
  const postId = parseInt(modalManager.getQueryParameter('posts'));
  const { data, isLoading } = useQuery(queryKey.postDetail(postId), () =>
    PostApi.detail(postId),
  );

  return (
    <DuplicatePostsModal
      modalHistory={props.modalHistory}
      modalManager={props.modalManager}
      pages={pages}
      user={user}
      initialPosts={data ? [data] : []}
      isLoading={isLoading}
    />
  );
};

export default DashboardDuplicatePostsModal;
